import classes from './InsertStrategyPicker.module.css';
import OptionTilePicker from './OptionTilePicker';

// Where the block goes relative to the element the CSS selector names. The
// five values are `insertAdjacentPosition`'s, plus a `replace` of our own, and
// the difference between them is purely spatial — "Before" and "Beginning of"
// are one word apart and a whole box apart, which a label alone never showed.
//
// The element already on the page is outlined; the block being inserted is
// filled. The element keeps a line of its own content, so "inside it" and
// "next to it" are tellable apart at this size.
const element = (...children) => <span className={classes.target}>{children}</span>;
const block = (key) => <span key={key} className={classes.block} />;
const content = (key) => <span key={key} className={classes.content} />;

const STRATEGIES = [
  {
    value: 'beforebegin',
    label: 'Before',
    hint: 'Above the element, outside it.',
    glyph: [block('b'), element(content('c'))],
  },
  {
    value: 'afterbegin',
    label: 'Beginning of',
    hint: 'Inside the element, before everything already in it.',
    glyph: [element(block('b'), content('c'))],
  },
  {
    value: 'beforeend',
    label: 'End of',
    hint: 'Inside the element, after everything already in it.',
    glyph: [element(content('c'), block('b'))],
  },
  {
    value: 'afterend',
    label: 'After',
    hint: 'Below the element, outside it.',
    glyph: [element(content('c')), block('b')],
  },
  {
    value: 'replace',
    label: 'Replace',
    hint: 'The block takes the element’s place, and the element is removed.',
    glyph: [<span key="b" className={classes.block} data-fills />],
  },
];

const InsertStrategyPicker = ({ value, onChange }) => (
  <OptionTilePicker
    label="Insert strategy"
    value={value}
    onChange={onChange}
    options={STRATEGIES.map((strategy) => ({
      ...strategy,
      glyph: <div className={classes.canvas}>{strategy.glyph}</div>,
    }))}
  />
);

export default InsertStrategyPicker;
